import { useTranslation } from 'react-i18next'

import { BaseModalProps } from '@app/context/ModalsContext'
import { useProductReadContext } from '@app/context/ProductContext'

import { Modal } from '@ui/components/Modal'

interface Props extends BaseModalProps {
  title: string
  description: string
  onConfirm: () => void
}

export const ShortRiskWarningModal: React.FC<Props> = (props) => {
  const { close, onConfirm } = props
  const { t } = useTranslation()
  const { title = t('riskWarning.Risk Warning') } = props

  const { isDefaultCFDProductType } = useProductReadContext()

  const isProductTypeCFD = isDefaultCFDProductType()
  const {
    description = isProductTypeCFD ? t('riskWarning.CFD simple') : t('riskWarning.ETD simple'),
  } = props

  const handleExit = () => {
    close()
    onConfirm()
  }

  return (
    <Modal>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>{description}</Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={handleExit}>{t('OK')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
